module.exports = __webpack_public_path__ + "fonts/fa-solid-900.d745348d.woff";